import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, LL_H_C, LL_V_L, ModuleFE_MouseInteractivity, mouseInteractivity_PopUp, ProtoComponent, SimpleListAdapter, stopPropagation, TS_Tree } from '@nu-art/thunderstorm-frontend/index';
import './Panel_DiseaseViews.scss';
import { removeItemFromArray, sortArray } from '@nu-art/ts-common';
import { PanelHeader } from '@app/hcs-frontend';
import { Dialog_ViewConfigEditor } from '../../dialogs/index.js';
import { Renderer_AlertWarningForDP } from '../../renderers/index.js';
import { ConfigKeyFE_DPViewOrder, ModuleFE_DiseaseView, ModuleFE_MultiVar, } from '../../../_entity.js';
import { DBDef_DiseaseProfile, DBDef_DiseaseView, noConnectedViewDPView } from '@app/dp-shared';
export class Panel_DiseaseViews extends ProtoComponent {
    // ######################### Static #########################
    static defaultProps = {
        keys: ['selected'],
    };
    // ######################### Life Cycle #########################
    __onMultiVarUpdated(...params) {
        switch (params[0]) {
            case 'create':
            case 'upsert-all':
            case 'delete':
            case 'delete-multi':
                this.reDeriveState();
                break;
        }
    }
    __onDiseaseViewUpdated(...params) {
        this.reDeriveState();
    }
    deriveStateFromProps(nextProps, state) {
        const selected = this.getQueryParam('selected', {});
        state.selectedDiseaseViewId = selected[DBDef_DiseaseView.dbKey];
        state.selectedDiseaseProfileId = selected[DBDef_DiseaseProfile.dbKey];
        const multiVarsForSelectedDP = ModuleFE_MultiVar.cache.filter(mv => mv.diseaseProfileId === state.selectedDiseaseProfileId);
        state.multiVarsPerView = ModuleFE_DiseaseView.cache.all().reduce((acc, dv) => {
            acc[dv._id] = multiVarsForSelectedDP.filter(mv => ModuleFE_DiseaseView.filterMultiVarByEnforcedTag(dv, mv));
            acc[dv._id].forEach(mv => removeItemFromArray(multiVarsForSelectedDP, mv));
            return acc;
        }, {});
        //Remaining multivars are ones that aren't assigned any DV
        state.multiVarsWithNoViews = multiVarsForSelectedDP;
        //Set selected disease view if none selected
        if (!state.selectedDiseaseViewId) {
            const firstDV = this.getSortedViews()[0];
            if (!firstDV)
                return state;
            const _selected = { ...selected };
            _selected[DBDef_DiseaseView.dbKey] = firstDV._id;
            this.setQueryParam('selected', _selected);
            state.selectedDiseaseViewId = firstDV._id;
        }
        return state;
    }
    // ######################### Logic #########################
    onViewSelect(item) {
        const selected = { ...this.getQueryParam('selected', {}) };
        if (selected[DBDef_DiseaseView.dbKey] === item._id)
            return;
        selected[DBDef_DiseaseView.dbKey] = item._id;
        this.setQueryParam('selected', selected);
    }
    onViewRightClick(e, view) {
        stopPropagation(e);
        if (!e.shiftKey)
            return;
        const menuItems = [
            { label: 'Add View Config', onClick: () => Dialog_ViewConfigEditor.show() },
        ];
        if (view)
            menuItems.push({ label: 'Edit View Config', onClick: () => Dialog_ViewConfigEditor.show(view) });
        const rightClickMenu = {
            id: 'panel-views-menu',
            adapter: SimpleListAdapter(menuItems, renderer => _jsx("div", { className: 'node-data', children: renderer.item.label })),
            originPos: { y: e.clientY, x: e.clientX, },
            modalPos: { x: 0, y: 1 },
            onNodeClicked: (path, item) => {
                ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                item.onClick?.();
            }
        };
        ModuleFE_MouseInteractivity.showMenu(rightClickMenu);
    }
    getSortedViews() {
        const viewsOrder = ConfigKeyFE_DPViewOrder.get() || [];
        return sortArray(ModuleFE_DiseaseView.cache.allMutable(), item => viewsOrder.indexOf(item._id));
    }
    ;
    // ######################### Render #########################
    renderDiseaseCount(diseaseViewId) {
        const count = diseaseViewId === noConnectedViewDPView._id
            ? this.state.multiVarsWithNoViews?.length
            : this.state.multiVarsPerView[diseaseViewId]?.length;
        if (!count)
            return '';
        return _jsx("span", { className: 'disease-value-count', children: count });
    }
    renderDiseaseView = (dv) => {
        return _jsxs(LL_H_C, { className: _className('node-data', dv._id === noConnectedViewDPView._id ? 'misc' : undefined), onContextMenu: e => this.onViewRightClick(e, dv), children: [_jsx("label", { children: dv.label }), _jsxs(LL_H_C, { children: [_jsx(Renderer_AlertWarningForDP, { relatedMultiVars: this.state.multiVarsPerView[dv._id] }), this.renderDiseaseCount(dv._id)] })] });
    };
    render() {
        const views = this.getSortedViews();
        if (this.state.multiVarsWithNoViews.length)
            views.push(noConnectedViewDPView);
        const adapter = SimpleListAdapter(views, (item) => this.renderDiseaseView(item.item));
        const selectedView = ModuleFE_DiseaseView.cache.unique(this.state.selectedDiseaseViewId);
        return _jsxs(LL_V_L, { className: 'panel__disease-properties', children: [_jsx(PanelHeader, { title: 'Disease Views' }), _jsx("div", { className: 'panel__main', onContextMenu: this.onViewRightClick, children: _jsx(TS_Tree, { adapter: adapter, selectedItem: selectedView, onNodeClicked: (path, item) => this.onViewSelect(item) }) })] });
    }
}
//# sourceMappingURL=Panel_DiseaseViews.js.map